// extracted by mini-css-extract-plugin
module.exports = {"information":"Information_information__1u9EE"};